<template>
  <div class="role">
    <div class="d-flex justify-content-between">
      <h4>{{name}}</h4>

      <div>
        <slot name="after-name">
        </slot>
      </div>
    </div>

    <p>{{role.description}}</p>

    <div>
      <h6>{{$t('roles.subroles')}}</h6>
      <span>{{subRoles}}</span>
    </div>
  </div>    
</template>

<script>
import { RoleService } from '@/api/AuthService'

export default {
  props: {
    role: {
      type: Object,
      required: true
    }
  },
  computed: {
    name: function () {
      return `${this.role.name} (${this.role.roleInfoTypes.length} ${this.$t('role.permissions')})` 
    },
    subRoles: function () {
      return this.role.subRoles.map(sr => sr.name).join(';  ') || this.$t('roles.no_subroles')
    }
  }
}
</script>
<style lang="scss">

.role {
  padding: 1rem 0;
  border-top: solid 1px #e3e3e3;
}

</style>